import React from 'react'
import Privacypolicy from '../../components/Privacypolicy/Privacypolicy'
import Layout from '../../components/Layout/Layout'

const Privacypolicies = () => {
  return (
    <div>
        <Layout>
        <Privacypolicy/>
        </Layout>
    </div>
  )
}

export default Privacypolicies